/* Serené · Mojo en vivo — llamada de voz con el asesor IA animado.
 * Abre con MojoLive.open() (botón del header). Manos libres: escucha (VAD),
 * Gemini entiende y responde como vendedor, ElevenLabs le pone voz y Mojo se
 * mueve, cambia de look, parpadea, habla, se ríe y baila según la emoción.
 * Endpoint: data-endpoint (…/voice). Assets: data-assets (carpeta de assets).
 */
(function () {
  "use strict";
  try { if (window.top !== window) return; } catch (e) { return; } // nunca dentro de iframes (web-pixels comparte sessionStorage)
  if (window.MojoLive) return;
  var SCRIPT = document.currentScript;
  var ENDPOINT = (SCRIPT && SCRIPT.getAttribute("data-endpoint")) || "https://serene-chat.davidandradebar.workers.dev/voice";
  var ASSETS = (SCRIPT && SCRIPT.getAttribute("data-assets")) || "";
  var A = function (f) { return ASSETS + f; };

  // Geometría (lienzo 760x720) de boca y ojos por look — generada del rig.
  var GEO = {
    base: { mouth: [388.5, 333, 89], eyes: [[287.5, 279.5, 33.5, 46.5], [492, 280, 33, 46]], mp: [327, 297, 123, 73], ep: [239, 218, 302, 124] },
    nerd: { mouth: [387.5, 334, 83], eyes: [[286.5, 279.5, 35.5, 46.5], [489, 280, 34, 46]], mp: [329, 300, 117, 69], ep: [236, 218, 303, 124] },
    perfume: { mouth: [366, 321.5, 80], eyes: [[279, 253.5, 34, 40.5], [471.5, 302, 32.5, 41]], mp: [309, 283, 115, 77], ep: [230, 198, 289, 161] },
    cool: { mouth: [392.5, 336, 83], eyes: [], mp: [334, 302, 117, 69] },
    tropical: { mouth: [418.5, 309.5, 83], eyes: [], mp: [360, 273, 117, 73] }
  };
  var LOOKS = ["base", "cool", "tropical", "nerd", "perfume"];
  // brazos separados: caja (lienzo 760x720) y pivote del hombro; ARMK = cuánto se pueden mover por look
  var ARMS = {"base":{"L":{"box":[53,344,150,163],"pivot":[192,396]},"R":{"box":[560,344,150,163],"pivot":[570,396]}},"cool":{"L":{"box":[59,346,150,164],"pivot":[198,398]},"R":{"box":[548,346,154,164],"pivot":[558,398]}},"tropical":{"L":{"box":[54,350,175,177],"pivot":[218,408]},"R":{"box":[590,322,139,141],"pivot":[604,432]}},"nerd":{"L":{"box":[60,324,201,225],"pivot":[232,398]},"R":{"box":[568,272,136,275],"pivot":[586,434]}},"perfume":{"L":{"box":[29,228,236,289],"pivot":[236,426]},"R":{"box":[431,366,148,161],"pivot":[468,408]}}};
  var ARMK = { base: 1, cool: 1, tropical: 0.32, nerd: 0.3, perfume: 0.3 };
  // la imagen original de algunos looks viene ladeada → se endereza (grados)
  var TILT = { perfume: -7, tropical: 3 };
  var BG = {
    base: "radial-gradient(120% 80% at 50% 25%,#ffb766 0%,#ff8a2b 38%,#2a1a3a 100%)",
    cool: "radial-gradient(120% 80% at 50% 25%,#7b5cff 0%,#2d2170 45%,#0d0a1f 100%)",
    tropical: "radial-gradient(120% 80% at 50% 25%,#7ef0d0 0%,#1fb6a6 40%,#0b3b4a 100%)",
    nerd: "radial-gradient(120% 80% at 50% 25%,#9ad0ff 0%,#3a6fd8 42%,#0f1b3d 100%)",
    perfume: "radial-gradient(120% 80% at 50% 25%,#ffe08a 0%,#ff9b29 42%,#3b1a12 100%)"
  };
  var pct = function (v, base) { return (v / base * 100) + "%"; };

  // ── estilos ────────────────────────────────────────────────────────
  var css = [
    /* el tema oculta div:empty → forzar las capas decorativas */
    ".mjl div.mjl-dim,.mjl div.mjl-bg,.mjl div.mjl-bg2,.mjl div.mjl-disco,.mjl div.mjl-shadow,.mjl div.mjl-ring,.mjl div.mjl-fx,.mjl div.mjl-poof,.mjl div.mjl-cf,.mjl div.mjl-cards,.mjl div.mjl-cap,.mjl div.mjl-sp,.mjl div.mjl-toast{display:block!important}",
    ".mjl{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;font-family:Poppins,system-ui,-apple-system,sans-serif;-webkit-font-smoothing:antialiased}",
    ".mjl-dim{position:absolute;inset:0;background:rgba(8,6,20,.55);backdrop-filter:blur(3px);opacity:0;transition:opacity .3s}",
    ".mjl.on .mjl-dim{opacity:1}",
    ".mjl-card{position:relative;width:100%;height:100%;overflow:hidden;color:#fff;display:flex;flex-direction:column;transform:translateY(30px) scale(.98);opacity:0;transition:transform .45s cubic-bezier(.2,1.2,.3,1),opacity .3s}",
    ".mjl.on .mjl-card{transform:none;opacity:1}",
    "@media(min-width:700px){.mjl-card{width:430px;height:min(880px,94vh);border-radius:30px;box-shadow:0 30px 80px rgba(0,0,0,.5)}}",
    ".mjl-bg,.mjl-bg2{position:absolute;inset:0;transition:opacity .9s ease}",
    ".mjl-bg2{opacity:0}",
    ".mjl-disco{position:absolute;left:50%;top:40%;width:190%;aspect-ratio:1;margin:-95% 0 0 -95%;border-radius:50%;background:conic-gradient(from 0deg,rgba(255,80,160,.32),rgba(80,200,255,.32),rgba(255,230,80,.32),rgba(120,255,140,.32),rgba(255,80,160,.32));filter:blur(28px);opacity:0;transition:opacity .4s;animation:mjlSpin 3s linear infinite}",
    ".mjl.dance .mjl-disco{opacity:1}",
    "@keyframes mjlSpin{to{transform:rotate(360deg)}}",
    ".mjl-top{position:relative;z-index:3;display:flex;align-items:center;gap:10px;padding:calc(14px + env(safe-area-inset-top,0px)) 16px 8px}",
    ".mjl-live{display:flex;align-items:center;gap:7px;font-size:13px;font-weight:700;letter-spacing:.02em;background:rgba(0,0,0,.25);padding:7px 12px;border-radius:99px}",
    ".mjl-live i{width:8px;height:8px;border-radius:50%;background:#3ddc84;box-shadow:0 0 0 0 rgba(61,220,132,.6);animation:mjlPulse 1.6s infinite}",
    "@keyframes mjlPulse{70%{box-shadow:0 0 0 8px rgba(61,220,132,0)}100%{box-shadow:0 0 0 0 rgba(61,220,132,0)}}",
    ".mjl-sp{flex:1}",
    ".mjl-ib{width:42px;height:42px;border-radius:50%;border:0;background:rgba(0,0,0,.28);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent}",
    ".mjl-stage{position:relative;z-index:2;flex:1 1 auto;min-height:0;display:flex;align-items:flex-end;justify-content:center;padding:0 10px}",
    ".mjl-char{position:relative;width:min(88%,46vh,380px);aspect-ratio:760/720;transform-origin:50% 96%;will-change:transform}",
    ".mjl-char img,.mjl-char svg{position:absolute;pointer-events:none;user-select:none;-webkit-user-drag:none}",
    ".mjl-look{left:0;top:0;width:100%;height:100%;opacity:0;transition:opacity .12s}",
    ".mjl-look.on{opacity:1}",
    ".mjl-arm{opacity:0;will-change:transform}.mjl-arm.on{opacity:1}",
    ".mjl-mp{opacity:0;transition:opacity .14s}.mjl-ep{opacity:0}",
    ".mjl-shadow{position:absolute;left:22%;right:22%;bottom:1%;height:6%;border-radius:50%;background:radial-gradient(closest-side,rgba(0,0,0,.45),rgba(0,0,0,0));z-index:-1}",
    ".mjl-fx{position:absolute;inset:0;pointer-events:none;overflow:visible}",
    ".mjl-p{position:absolute;font-size:30px;will-change:transform,opacity;animation:mjlFloat 1.6s ease-out forwards}",
    "@keyframes mjlFloat{0%{opacity:0;transform:translate(0,10px) scale(.4) rotate(0)}15%{opacity:1}100%{opacity:0;transform:translate(var(--dx),-140px) scale(1.15) rotate(var(--rt))}}",
    ".mjl-cf{position:absolute;top:-4%;width:9px;height:14px;border-radius:2px;animation:mjlFall 2.2s cubic-bezier(.3,.6,.6,1) forwards}",
    "@keyframes mjlFall{to{transform:translate(var(--dx),115%) rotate(var(--rt));opacity:.0}}",
    ".mjl-poof{position:absolute;border-radius:50%;background:#fff;opacity:.95;animation:mjlPoof .55s ease-out forwards}",
    "@keyframes mjlPoof{from{transform:scale(.2)}to{transform:scale(1.6);opacity:0}}",
    ".mjl-think{position:absolute;right:4%;top:2%;display:flex;gap:6px;background:#fff;color:#2a1a3a;border-radius:22px;padding:10px 14px;opacity:0;transform:scale(.6);transition:all .3s cubic-bezier(.2,1.4,.4,1)}",
    ".mjl.thinking .mjl-think{opacity:1;transform:none}",
    ".mjl-think b{width:8px;height:8px;border-radius:50%;background:#ff9b29;animation:mjlDot 1s infinite}",
    ".mjl-think b:nth-child(2){animation-delay:.15s}.mjl-think b:nth-child(3){animation-delay:.3s}",
    "@keyframes mjlDot{0%,60%,100%{transform:translateY(0);opacity:.4}30%{transform:translateY(-5px);opacity:1}}",
    ".mjl-ring{position:absolute;left:50%;top:55%;width:70%;aspect-ratio:1;border-radius:50%;border:3px solid rgba(255,255,255,.55);transform:translate(-50%,-50%) scale(.8);opacity:0;z-index:-1}",
    ".mjl.listening .mjl-ring{animation:mjlRing 1.8s infinite}",
    ".mjl.listening .mjl-ring:nth-child(2){animation-delay:.6s}",
    "@keyframes mjlRing{0%{opacity:.6;transform:translate(-50%,-50%) scale(.75)}100%{opacity:0;transform:translate(-50%,-50%) scale(1.3)}}",
    ".mjl-bottom{position:relative;z-index:3;padding:10px 16px calc(16px + env(safe-area-inset-bottom,0px));display:flex;flex-direction:column;gap:10px;background:linear-gradient(to top,rgba(0,0,0,.55),rgba(0,0,0,0))}",
    ".mjl-cap{min-height:66px;max-height:24vh;overflow:auto;font-size:16px;line-height:1.45;font-weight:500;text-shadow:0 1px 8px rgba(0,0,0,.35)}",
    ".mjl-cap small{display:block;opacity:.75;font-size:13px;margin-bottom:4px}",
    ".mjl-cards{display:flex;gap:10px;overflow-x:auto;padding-bottom:2px}",
    ".mjl-pc{flex:0 0 auto;display:flex;gap:10px;align-items:center;background:#fff;color:#1a1a2e;border-radius:16px;padding:8px 10px 8px 8px;min-width:250px;max-width:300px;box-shadow:0 8px 24px rgba(0,0,0,.25);animation:mjlIn .35s cubic-bezier(.2,1.3,.4,1)}",
    "@keyframes mjlIn{from{transform:translateY(14px) scale(.95);opacity:0}}",
    ".mjl-pc img{width:54px;height:54px;border-radius:10px;object-fit:cover;background:#f2f2f5}",
    ".mjl-pc .t{flex:1;min-width:0;font-size:12.5px;line-height:1.25}",
    ".mjl-pc .t b{display:block;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
    ".mjl-pc button,.mjl-cta{border:0;border-radius:99px;background:#1a1a2e;color:#fff;font:700 12.5px Poppins,system-ui,sans-serif;padding:9px 12px;cursor:pointer;white-space:nowrap}",
    ".mjl-pc button.ok{background:#1f8a4c}",
    ".mjl-cta{background:#ff9b29;color:#1a1a2e;font-size:14px;padding:12px 16px;align-self:center}",
    ".mjl-chips{display:none;flex-wrap:wrap;gap:8px;justify-content:center;margin:2px 0 4px}.mjl-chips.on{display:flex}",
    ".mjl-chip{border:0;border-radius:99px;padding:9px 14px;font:600 14px Poppins,system-ui,sans-serif;background:rgba(255,255,255,.92);color:#1a1a2e;cursor:pointer;box-shadow:0 4px 12px rgba(0,0,0,.12);transition:transform .15s}.mjl-chip:active{transform:scale(.95)}",
    ".mjl.mini .mjl-chip{padding:7px 11px;font-size:12.5px;background:#f3f3f6}",
    ".mjl-pay{display:flex;gap:8px;justify-content:center;flex-wrap:wrap}.mjl-pay .mjl-cta{flex:1 1 140px}.mjl-pay .alt{background:#1a1a2e;color:#fff}",
    ".mjl-row{display:flex;gap:10px;align-items:center}",
    ".mjl-mic{flex:0 0 auto;width:64px;height:64px;border-radius:50%;border:0;background:#fff;color:#1a1a2e;font-size:26px;cursor:pointer;position:relative;box-shadow:0 8px 24px rgba(0,0,0,.3)}",
    ".mjl.listening .mjl-mic{background:#3ddc84;color:#fff}",
    ".mjl.paused .mjl-mic{background:rgba(255,255,255,.35);color:#fff}",
    ".mjl-lvl{position:absolute;inset:-6px;border-radius:50%;border:3px solid rgba(61,220,132,.8);transform:scale(var(--l,1));transition:transform .08s}",
    ".mjl-state{flex:1;font-size:13.5px;opacity:.9}",
    ".mjl-txt{flex:1;display:none;gap:8px}",
    ".mjl.typing .mjl-txt{display:flex}.mjl.typing .mjl-state{display:none}",
    ".mjl-txt input{flex:1;border:0;border-radius:99px;padding:12px 15px;font:15px Poppins,system-ui,sans-serif;outline:none}",
    ".mjl-txt button{border:0;border-radius:99px;background:#ff9b29;color:#1a1a2e;font-weight:800;padding:0 16px;cursor:pointer}",
    ".mjl-links{display:flex;justify-content:center;gap:16px;font-size:12.5px}",
    ".mjl-links a{color:#fff;opacity:.85;text-decoration:underline;cursor:pointer}",
    ".mjl-toast{position:absolute;left:50%;top:calc(70px + env(safe-area-inset-top,0px));transform:translate(-50%,-12px);background:#fff;color:#1a1a2e;font-weight:700;font-size:13.5px;padding:10px 16px;border-radius:99px;box-shadow:0 10px 30px rgba(0,0,0,.3);opacity:0;transition:all .3s;z-index:5;white-space:nowrap}",
    ".mjl-toast.on{opacity:1;transform:translate(-50%,0)}",
    /* ── modo mini: Mojo pequeño en la esquina, sin fondo, la página sigue navegable ── */
    ".mjl.mini{inset:auto;right:10px;bottom:calc(10px + env(safe-area-inset-bottom,0px));left:auto;top:auto;pointer-events:none;align-items:flex-end;justify-content:flex-end}",
    ".mjl.mini .mjl-dim,.mjl.mini div.mjl-bg,.mjl.mini div.mjl-bg2,.mjl.mini div.mjl-disco,.mjl.mini .mjl-top,.mjl.mini .mjl-links,.mjl.mini .mjl-think{display:none!important}",
    ".mjl.mini .mjl-card{width:min(340px,94vw);height:auto;background:none!important;box-shadow:none;border-radius:0;overflow:visible;display:flex;flex-direction:row;align-items:flex-end;gap:6px;pointer-events:none}",
    ".mjl.mini .mjl-stage{order:2;flex:0 0 118px;padding:0;pointer-events:auto}",
    ".mjl.mini .mjl-char{width:118px}",
    ".mjl.mini .mjl-bottom{order:1;flex:1;min-width:0;pointer-events:auto;background:#fff;color:#1a1a2e;border-radius:18px 18px 4px 18px;padding:10px 12px 10px;box-shadow:0 10px 30px rgba(0,0,0,.22);gap:8px;margin-bottom:30px}",
    ".mjl.mini .mjl-cap{min-height:0;max-height:26vh;font-size:14px;line-height:1.4;text-shadow:none;color:#1a1a2e}",
    ".mjl.mini .mjl-cap small{color:#666}",
    ".mjl.mini .mjl-mic{width:40px;height:40px;font-size:17px;box-shadow:0 4px 12px rgba(0,0,0,.15);background:#1a1a2e;color:#fff}",
    ".mjl.mini.listening .mjl-mic{background:#3ddc84}",
    ".mjl.mini .mjl-state{font-size:12px;color:#555}",
    ".mjl.mini .mjl-pc{min-width:0;max-width:100%;box-shadow:none;border:1px solid #eee;padding:6px}",
    ".mjl.mini .mjl-pc img{width:42px;height:42px}",
    ".mjl.mini .mjl-pc .t{font-size:12px;line-height:1.25}.mjl.mini .mjl-pc .t b{white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.mjl.mini .mjl-pc button{padding:7px 9px;font-size:12px}",
    ".mjl.mini .mjl-cta{font-size:13px;padding:9px 12px}",
    ".mjl-mbar{display:none;justify-content:flex-end;gap:6px;margin:-4px -4px 0 0}",
    ".mjl.mini .mjl-mbar{display:flex}",
    ".mjl.mini{transition:bottom .28s cubic-bezier(.2,.8,.2,1)}",
    ".mjl.mini.squeeze .mjl-bottom{display:none}",
    ".mjl.mini .mjl-txt{min-width:0;gap:6px}.mjl.mini .mjl-txt input{min-width:0;width:100%;padding:9px 11px;font-size:14px;background:#f3f3f6}.mjl.mini .mjl-txt button{padding:0 11px;flex:0 0 auto}",
    ".mjl-mbar button{border:0;background:#f1f1f4;color:#1a1a2e;border-radius:99px;font-size:12px;font-weight:700;padding:5px 9px;cursor:pointer}",
    /* ── A/B del arranque, variante B: chips grandes y visibles + nota del permiso del micrófono ── */
    ".mjl.ab-b .mjl-chips{gap:10px;margin:6px 0 8px}.mjl.ab-b .mjl-chip{padding:13px 18px;font-size:16px;background:#fff;border:2px solid #ff9b29;box-shadow:0 6px 18px rgba(0,0,0,.22)}",
    ".mjl.mini.ab-b .mjl-chip{padding:8px 12px;font-size:13.5px;background:#fff}",
    ".mjl-micnote{display:none;font-size:12.5px;line-height:1.35;background:rgba(0,0,0,.35);border-radius:12px;padding:8px 10px;text-align:center}.mjl.micask .mjl-micnote{display:block}.mjl.mini .mjl-micnote{background:#f3f3f6;color:#1a1a2e}",
    ".mjl-tap{display:none;border:0;border-radius:99px;background:#ff9b29;color:#1a1a2e;font-weight:800;font-size:13px;padding:9px 12px;cursor:pointer}",
    ".mjl.needtap .mjl-tap{display:inline-block}",
    "@media (prefers-reduced-motion:reduce){.mjl-p,.mjl-cf,.mjl-disco{animation:none!important;display:none}}"
  ].join("");

  // ── utilidades ─────────────────────────────────────────────────────
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function plain(md) { return String(md || "").replace(/\*\*\[[^\]]*\]\([^)]+\)\*\*/g, "").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/\*\*/g, "").replace(/\s{2,}/g, " ").trim(); }
  function silentWavUrl() {
    var n = 800, b = new ArrayBuffer(44 + n * 2), v = new DataView(b);
    function w(o, s) { for (var i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); }
    w(0, "RIFF"); v.setUint32(4, 36 + n * 2, true); w(8, "WAVE"); w(12, "fmt "); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
    v.setUint32(24, 8000, true); v.setUint32(28, 16000, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true); w(36, "data"); v.setUint32(40, n * 2, true);
    return URL.createObjectURL(new Blob([b], { type: "audio/wav" }));
  }
  function ssGet(k, d) { try { var x = sessionStorage.getItem(k); return x ? JSON.parse(x) : d; } catch (e) { return d; } }

  // ── estado ─────────────────────────────────────────────────────────
  var armEls = {}, armA = { L: 0, R: 0 }, armV = { L: 0, R: 0 }, greetWave = false;
  var root, card, bg, bg2, ch, looks = {}, mp, ep, mouthSvg, eyesSvg, fx, cap, cards, stateTxt, micBtn, lvl, txtIn;
  var built = false, isOpen = false, look = "base", phase = "idle", emotion = "happy", emoT0 = 0, history = [], muted = false, paused = false;
  var audioEl = null, actx = null, stream = null, analyser = null, rec = null, chunks = [], vadTimer = null, busy = false, greeted = false;
  var speakingSince = 0, nextBlink = 0, blinkUntil = 0, squint = false, winkSide = -1, spinFrames = null, spinT0 = 0, lastSpin = 0;
  var cur = { x: 0, y: 0, r: 0, sx: 1, sy: 1 }, vel = { x: 0, y: 0, r: 0, sx: 0, sy: 0 }, lastF = 0, lookT0 = -9, shadowEl = null;
  var productInfo = null, mo = 0, profile = "", sameLook = 0, mini = false, pendingGo = null, arrived = "", goArrive = "";
  var STATE_KEY = "mjl_state_v1";
  // A/B del arranque (50/50 por visitante, fijo en localStorage). B = chips grandes de inmediato, texto por defecto
  // en móvil (micrófono opcional con botón) y una línea que explica el permiso del micrófono. ?mjl_ab=A|B lo fuerza (QA).
  var AB = (function () {
    var v = "";
    try { v = (location.search.match(/[?&]mjl_ab=([AB])\b/) || [])[1] || localStorage.getItem("mjl_ab") || ""; } catch (e) {}
    if (v !== "A" && v !== "B") v = Math.random() < 0.5 ? "A" : "B";
    try { localStorage.setItem("mjl_ab", v); } catch (e) {}
    return v;
  })();
  var IS_MOBILE = (function () { try { return window.matchMedia("(pointer:coarse)").matches || window.innerWidth < 768; } catch (e) { return false; } })();
  function voiceChosen() { try { return sessionStorage.getItem("mjl_voice") === "1"; } catch (e) { return false; } }
  function textFirst() { return AB === "B" && IS_MOBILE && !voiceChosen(); }
  var talked = false, micNote = null, aTypeEl = null;
  function setTyping(on) {
    root.classList.toggle("typing", !!on);
    if (AB === "B" && aTypeEl) aTypeEl.textContent = on ? "🎙️ Prefiero hablar" : "⌨️ Escribir en vez de hablar";
  }
  function saveState(extra) {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(Object.assign({ open: isOpen, mini: mini, history: history.slice(-20), profile: profile, look: look, greeted: greeted, arrive: goArrive || ((readState() || {}).arrive) || "", t: Date.now() }, extra || {}))); } catch (e) {}
  }
  function readState() { try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || "null"); } catch (e) { return null; } }
  function setMini(v) {
    mini = !!v; if (!root) return;
    root.classList.toggle("mini", mini);
    document.documentElement.style.overflow = (isOpen && !mini) ? "hidden" : "";
    saveState();
    queueDodge();
  }
  // ── en mini, nunca tapar el botón de compra: se sube por encima del "Añadir al carrito" o la barra fija ─
  var ATC_SEL = 'form[action*="/cart/add"] button[type="submit"],button[name="add"],.product-form__submit,.mp-stickybar,.shopify-payment-button__button,.es-popup-button,#es-popup-button,[class*="sticky-atc"],[class*="sticky-add"]';
  var dodgeRaf = 0, dodgeLift = -1, dodgeFullH = 0;
  function dodge() {
    dodgeRaf = 0;
    if (!root || !isOpen || !mini) { if (root && dodgeLift !== -1) { root.style.bottom = ""; root.classList.remove("squeeze"); dodgeLift = -1; } return; }
    var card = root.querySelector(".mjl-card"); if (!card) return;
    var vh = window.innerHeight, vw = window.innerWidth, h = card.offsetHeight, w = card.offsetWidth;
    var base = 10, left = vw - 10 - w, blocks = [];
    document.querySelectorAll(ATC_SEL).forEach(function (t) {
      if (root.contains(t)) return;
      var r = t.getBoundingClientRect(); if (!r.width || !r.height || r.bottom <= 0 || r.top >= vh) return;
      var cs = getComputedStyle(t); if (cs.visibility === "hidden" || cs.display === "none" || +cs.opacity === 0) return;
      if (r.right <= left || r.left >= vw - 10) return;          // no cruza en horizontal
      blocks.push([r.top - 8, r.bottom + 8]);
    });
    // hueco libre más bajo donde quepa Mojo sin cruzar ningún botón de compra
    function slot(hh) {
      var cands = [vh - base].concat(blocks.map(function (b) { return b[0]; })).sort(function (a, b) { return b - a; });
      for (var k = 0; k < cands.length; k++) {
        var cb = Math.min(cands[k], vh - base), ct = cb - hh;
        if (ct < 56) continue;
        if (!blocks.some(function (b) { return b[0] < cb && b[1] > ct; })) return cb;
      }
      return 0;
    }
    if (!root.classList.contains("squeeze")) dodgeFullH = h;
    var bottomY = slot(dodgeFullH || h), squeeze = false;
    if (!bottomY) { // no cabe con el globo → solo el personaje (sigue hablando por audio)
      var st = root.querySelector(".mjl-stage"); squeeze = true;
      bottomY = slot(st ? st.offsetHeight : 140) || (vh - base);
    }
    root.classList.toggle("squeeze", squeeze);
    var lift = Math.round(vh - bottomY);
    if (lift !== dodgeLift) { dodgeLift = lift; root.style.bottom = lift === base ? "" : lift + "px"; }
  }
  function queueDodge() { if (!dodgeRaf) dodgeRaf = requestAnimationFrame(dodge); }
  window.addEventListener("scroll", queueDodge, { passive: true });
  window.addEventListener("resize", queueDodge);
  setInterval(function () { if (isOpen && mini) queueDodge(); }, 400);
  ["transitionend", "animationend"].forEach(function (ev) { document.addEventListener(ev, function (e) { if (isOpen && mini && !(root && root.contains(e.target))) queueDodge(); }, true); }); // barras fijas que aparecen solas / la burbuja cambia de alto
  var SID = "";
  function sessionId() { // se lee al abrir (no al cargar la página)
    try { var x = sessionStorage.getItem("mjl_sid"); if (!x) { x = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem("mjl_sid", x); } return x; } catch (e) { return "anon" + Date.now(); }
  }
  var evLog = [], lastSnap = "";
  // resumen completo de la conversación en UNA escritura (el servidor ya no guarda cada frase: cupo diario)
  function snapshot() {
    try {
      if (!SID || history.length < 2) return;
      var turns = [];
      for (var i = 0; i + 1 < history.length; i += 2) turns.push({ user: /^\(/.test(history[i].content || "") ? "" : String(history[i].content || "").slice(0, 400), mojo: String(history[i + 1].content || "").slice(0, 600) });
      var body = JSON.stringify({ sid: SID, type: "snapshot", ab: AB, turns: turns, profile: profile, events: evLog.slice(-40) });
      if (body === lastSnap) return; lastSnap = body;
      var url = ENDPOINT.replace(/\/voice$/, "/voice-event");
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
      else fetch(url, { method: "POST", body: body, keepalive: true });
    } catch (e) {}
  }
  window.addEventListener("pagehide", function () { if (isOpen) snapshot(); });
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden" && isOpen) snapshot(); });
  function logEv(type, data) {
    try { evLog.push({ t: Date.now(), type: type, sku: (data && data.sku) || "" }); } catch (e) {}
    try { var b = Object.assign({ sid: SID, type: type, ab: AB }, data || {}); fetch(ENDPOINT.replace(/\/voice$/, "/voice-event"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(b), keepalive: true }); } catch (e) {}
  }
  // respaldo: si el modelo repite look, Mojo se cambia solo a uno acorde a su emoción
  var LOOK_BY_EMO = { excited: ["tropical", "perfume"], dance: ["perfume", "tropical"], cool: ["cool"], wink: ["cool"], love: ["perfume", "cool"],
    thinking: ["nerd"], proud: ["perfume", "nerd"], laugh: ["tropical", "base"], surprised: ["nerd", "tropical"], shy: ["base", "nerd"], happy: ["tropical", "base", "cool"] };
  function pickLook(serverLook, emo) {
    var want = LOOKS.indexOf(serverLook) > -1 ? serverLook : look;
    if (want === look) sameLook++; else sameLook = 0;
    if (sameLook >= 1) {
      var opts = (LOOK_BY_EMO[emo] || LOOKS).filter(function (k) { return k !== look; });
      if (!opts.length) opts = LOOKS.filter(function (k) { return k !== look; });
      want = opts[Math.floor(Math.random() * opts.length)]; sameLook = 0;
    }
    return want;
  }

  function build() {
    if (built) return; built = true;
    var st = el("style"); st.textContent = css; document.head.appendChild(st);
    root = el("div", "mjl" + (AB === "B" ? " ab-b" : "")); root.setAttribute("role", "dialog"); root.setAttribute("aria-label", "Llamada con Mojo, asesor de fragancias de Serené");
    root.appendChild(el("div", "mjl-dim"));
    card = el("div", "mjl-card"); root.appendChild(card);
    bg = el("div", "mjl-bg"); bg2 = el("div", "mjl-bg2"); bg.style.background = BG.base;
    card.appendChild(bg); card.appendChild(bg2); card.appendChild(el("div", "mjl-disco"));
    var top = el("div", "mjl-top");
    top.appendChild(el("div", "mjl-live", "<i></i>Mojo · en vivo"));
    top.appendChild(el("div", "mjl-sp"));
    var muteB = el("button", "mjl-ib", "🔊"); muteB.setAttribute("aria-label", "Silenciar"); muteB.onclick = function () { muted = !muted; muteB.textContent = muted ? "🔇" : "🔊"; if (audioEl) audioEl.muted = muted; };
    var closeB = el("button", "mjl-ib", "✕"); closeB.setAttribute("aria-label", "Cerrar"); closeB.onclick = close;
    top.appendChild(muteB); top.appendChild(closeB); card.appendChild(top);

    var stage = el("div", "mjl-stage"); card.appendChild(stage);
    ch = el("div", "mjl-char"); stage.appendChild(ch);
    ch.appendChild(el("div", "mjl-ring")); ch.appendChild(el("div", "mjl-ring")); shadowEl = el("div", "mjl-shadow"); ch.appendChild(shadowEl);
    LOOKS.forEach(function (k) {
      var i = el("img", "mjl-look"); i.alt = ""; i.decoding = "async"; i.src = A("mojo-" + k + "-body.webp"); looks[k] = i; ch.appendChild(i);
    });
    looks.base.classList.add("on");
    mp = el("img", "mjl-mp"); ep = el("img", "mjl-ep"); ch.appendChild(mp); ch.appendChild(ep);
    var NS = "http://www.w3.org/2000/svg";
    mouthSvg = document.createElementNS(NS, "svg"); eyesSvg = document.createElementNS(NS, "svg");
    [mouthSvg, eyesSvg].forEach(function (s) { s.setAttribute("viewBox", "0 0 760 720"); s.style.cssText = "left:0;top:0;width:100%;height:100%"; ch.appendChild(s); });
    // brazos encima de cuerpo y cara (cada uno rota en su hombro)
    LOOKS.forEach(function (k) {
      ["L", "R"].forEach(function (sd) {
        var g = ARMS[k][sd], im = el("img", "mjl-arm"); im.alt = ""; im.decoding = "async"; im.src = A("mojo-" + k + "-arm" + sd + ".webp");
        im.style.left = pct(g.box[0], 760); im.style.top = pct(g.box[1], 720); im.style.width = pct(g.box[2], 760); im.style.height = pct(g.box[3], 720);
        im.style.transformOrigin = pct(g.pivot[0] - g.box[0], g.box[2]) + " " + pct(g.pivot[1] - g.box[1], g.box[3]);
        armEls[k + sd] = im; ch.appendChild(im);
      });
    });
    fx = el("div", "mjl-fx"); ch.appendChild(fx);
    ch.style.pointerEvents = "auto"; ch.style.cursor = "pointer";
    ch.addEventListener("click", function () { if (phase === "speaking" && audioEl && !audioEl.paused) { audioEl.pause(); if (audioEl.onended) audioEl.onended(); } else { burst(["💛", "✨"], 2); react("happy"); } });
    ch.appendChild(el("div", "mjl-think", "<b></b><b></b><b></b>"));

    var bottom = el("div", "mjl-bottom"); card.appendChild(bottom);
    var mbar = el("div", "mjl-mbar");
    var bExp = el("button", "", "⤢ Agrandar"); bExp.onclick = function () { setMini(false); };
    var bCls = el("button", "", "✕"); bCls.setAttribute("aria-label", "Cerrar"); bCls.onclick = close;
    mbar.appendChild(bExp); mbar.appendChild(bCls); bottom.appendChild(mbar);
    cap = el("div", "mjl-cap"); bottom.appendChild(cap);
    chips = el("div", "mjl-chips"); bottom.appendChild(chips);
    micNote = el("div", "mjl-micnote", "🎤 Tu navegador te va a pedir el micrófono: es solo para que Mojo te escuche durante la llamada. Si prefieres, escríbele o toca una opción."); bottom.appendChild(micNote);
    cards = el("div", "mjl-cards"); bottom.appendChild(cards);
    var row = el("div", "mjl-row"); bottom.appendChild(row);
    micBtn = el("button", "mjl-mic", "🎙️"); micBtn.setAttribute("aria-label", "Micrófono"); lvl = el("i", "mjl-lvl"); micBtn.appendChild(lvl);
    micBtn.onclick = function () { if (AB === "B" && root.classList.contains("typing")) { try { sessionStorage.setItem("mjl_voice", "1"); } catch (e) {} setTyping(false); } if (paused || phase === "idle") { paused = false; root.classList.remove("paused"); startListening(); } else { paused = true; stopListening(true); setPhase("idle"); root.classList.add("paused"); setState("Pausado · toca para hablar"); } };
    row.appendChild(micBtn);
    stateTxt = el("div", "mjl-state", "Conectando…"); row.appendChild(stateTxt);
    var tapB = el("button", "mjl-tap", "🔊 Toca para seguir"); tapB.onclick = function () {
      root.classList.remove("needtap");
      try { if (actx && actx.state === "suspended") actx.resume(); } catch (e) {}
      if (phase === "speaking" && audioEl && audioEl.paused && /^data:audio\/mpeg/.test(audioEl.src || "")) { var pp = audioEl.play(); if (pp && pp.catch) pp.catch(function () {}); }
      else { paused = false; root.classList.remove("paused"); startListening(); }
    }; row.appendChild(tapB);
    var tx = el("div", "mjl-txt"); txtIn = el("input"); txtIn.placeholder = "Escríbele a Mojo…"; txtIn.setAttribute("enterkeyhint", "send");
    var txB = el("button", "", "➤"); tx.appendChild(txtIn); tx.appendChild(txB); row.appendChild(tx);
    var sendTxt = function () { var v = txtIn.value.trim(); if (!v || busy) return; txtIn.value = ""; stopListening(true); turn({ text: v }, v); };
    txB.onclick = sendTxt; txtIn.addEventListener("keydown", function (e) { if (e.key === "Enter") sendTxt(); });
    var links = el("div", "mjl-links");
    var aType = el("a", "", "⌨️ Escribir en vez de hablar"); aTypeEl = aType; aType.onclick = function () {
      var on = !root.classList.contains("typing");
      if (!on && AB === "B") { try { sessionStorage.setItem("mjl_voice", "1"); } catch (e) {} }
      setTyping(on); if (on) { stopListening(true); setPhase("idle"); txtIn.focus(); } else if (AB === "B") { paused = false; root.classList.remove("paused"); startListening(); }
    };
    var aChat = el("a", "", "💬 Chat clásico"); aChat.onclick = function () { close(); setTimeout(function () { if (window.SereneChat) SereneChat.open(); }, 250); };
    links.appendChild(aType); links.appendChild(aChat); bottom.appendChild(links);
    document.body.appendChild(root);
    requestAnimationFrame(loop);
  }

  // ── look / fondo ───────────────────────────────────────────────────
  function setBg(k) { bg2.style.background = BG[k] || BG.base; bg2.style.opacity = "1"; setTimeout(function () { bg.style.background = BG[k] || BG.base; bg2.style.opacity = "0"; }, 900); }
  function applyLookImgs(k) {
    LOOKS.forEach(function (x) { looks[x].classList.toggle("on", x === k); armEls[x + "L"].classList.toggle("on", x === k); armEls[x + "R"].classList.toggle("on", x === k); });
    var g = GEO[k];
    mp.src = A("mojo-" + k + "-mouthpatch.webp");
    mp.style.left = pct(g.mp[0], 760); mp.style.top = pct(g.mp[1], 720); mp.style.width = pct(g.mp[2], 760); mp.style.height = pct(g.mp[3], 720);
    if (g.ep) { ep.src = A("mojo-" + k + "-eyepatch.webp"); ep.style.left = pct(g.ep[0], 760); ep.style.top = pct(g.ep[1], 720); ep.style.width = pct(g.ep[2], 760); ep.style.height = pct(g.ep[3], 720); }
  }
  function changeLook(k) {
    if (!GEO[k] || k === look) return;
    lookT0 = performance.now() / 1000; poof(); look = k;
    setTimeout(function () { applyLookImgs(k); }, 200);
    setBg(k);
  }
  function poof() {
    for (var i = 0; i < 7; i++) {
      var p = el("div", "mjl-poof"); var s = 70 + Math.random() * 90;
      p.style.cssText = "width:" + s + "px;height:" + s + "px;left:" + (30 + Math.random() * 40) + "%;top:" + (25 + Math.random() * 45) + "%;margin:-" + s / 2 + "px 0 0 -" + s / 2 + "px;animation-delay:" + (i * 30) + "ms";
      fx.appendChild(p); setTimeout(p.remove.bind(p), 800);
    }
    burst(["✨", "✨", "⭐"], 5);
  }
  function burst(list, n, opts) {
    opts = opts || {};
    for (var i = 0; i < n; i++) {
      (function (i) {
        setTimeout(function () {
          var p = el("div", "mjl-p", list[i % list.length]);
          p.style.left = (opts.x != null ? opts.x : 15 + Math.random() * 70) + "%"; p.style.top = (opts.y != null ? opts.y : 20 + Math.random() * 40) + "%";
          p.style.setProperty("--dx", (Math.random() * 120 - 60) + "px"); p.style.setProperty("--rt", (Math.random() * 60 - 30) + "deg");
          p.style.fontSize = (22 + Math.random() * 18) + "px";
          fx.appendChild(p); setTimeout(p.remove.bind(p), 1700);
        }, i * (opts.gap || 120));
      })(i);
    }
  }
  function confetti(n) {
    var cols = ["#ff9b29", "#ff5fa8", "#3ddc84", "#4fc3ff", "#ffe066", "#a78bfa"];
    for (var i = 0; i < n; i++) {
      var c = el("div", "mjl-cf"); c.style.left = Math.random() * 100 + "%"; c.style.background = cols[i % cols.length];
      c.style.setProperty("--dx", (Math.random() * 160 - 80) + "px"); c.style.setProperty("--rt", (Math.random() * 720 - 360) + "deg");
      c.style.animationDelay = Math.random() * 0.5 + "s"; card.appendChild(c); setTimeout(c.remove.bind(c), 2900);
    }
  }

  // ── emociones (one-shots al empezar a hablar) ──────────────────────
  function react(em) {
    if (em !== "thinking" && greetWave && history.length > 2) greetWave = false;
    emotion = em; emoT0 = performance.now(); squint = false; winkSide = -1;
    root.classList.toggle("dance", em === "dance");
    if (em === "laugh") { squint = true; burst(["😂", "jaja", "🤣"], 3); }
    else if (em === "love") { squint = true; burst(["💖", "💕", "💗", "💖"], 6, { gap: 160 }); }
    else if (em === "excited") { burst(["✨", "🤩", "✨"], 4); }
    else if (em === "surprised") { burst(["❗", "😮"], 2, { x: 70, y: 5 }); }
    else if (em === "wink") { winkSide = 1; burst(["😉", "✨"], 2, { x: 72, y: 15 }); }
    else if (em === "cool") { burst(["😎", "🔥"], 2, { x: 75, y: 12 }); }
    else if (em === "proud") { burst(["⭐", "🏆", "⭐"], 3); }
    else if (em === "shy") { squint = true; burst(["☺️"], 1, { x: 74, y: 12 }); }
    else if (em === "dance") { confetti(36); burst(["🎵", "🎶", "🎵", "🎶", "💃"], 8, { gap: 220 }); }
    else if (em === "thinking") { burst(["🤔"], 1, { x: 74, y: 8 }); }
  }

  // ── motor de movimiento (rAF) ──────────────────────────────────────
  function mouthOpen(t) {
    if (phase !== "speaking" || !audioEl || audioEl.paused) return 0;
    var e = Math.abs(Math.sin(t * 12.7) * Math.sin(t * 6.1 + 1.3)) * 0.85 + Math.abs(Math.sin(t * 21.3)) * 0.15;
    var gap = Math.sin(t * 2.3) + Math.sin(t * 3.7 + 2); // pausas entre palabras
    if (gap > 1.45) e *= 0.15;
    return Math.min(1, 0.12 + e);
  }
  function drawFace(t, o) {
    var g = GEO[look], spinning = !!spinFrames;
    // boca: mientras habla, el parche tapa la sonrisa original y se dibuja la boca
    // con su forma (comisuras arriba, abre en "D"); fuera de "speaking" vuelve la original.
    var talking = phase === "speaking" && !spinning;
    mp.style.opacity = talking ? "1" : "0";
    if (talking) {
      mo += (o - mo) * 0.35;
      var cx = g.mouth[0], cy = g.mouth[1], w = g.mouth[2] * 0.47, h = 4 + 40 * mo;
      var cyT = cy - 7, lift = 9;
      var L = (cx - w) + " " + (cyT - lift), R = (cx + w) + " " + (cyT - lift);
      var topC = cx + " " + (cyT + 6), botC = cx + " " + (cyT + 6 + h * 1.9);
      mouthSvg.innerHTML =
        '<defs><linearGradient id="mjlM" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3a1418"/><stop offset="1" stop-color="#0d0304"/></linearGradient>' +
        '<clipPath id="mjlC"><path d="M' + L + ' Q' + topC + ' ' + R + ' Q' + botC + ' ' + L + 'Z"/></clipPath></defs>' +
        (h > 7 ? '<path d="M' + L + ' Q' + topC + ' ' + R + ' Q' + botC + ' ' + L + 'Z" fill="url(#mjlM)"/>' +
          '<g clip-path="url(#mjlC)"><ellipse cx="' + cx + '" cy="' + (cyT + 6 + h * 0.95) + '" rx="' + (w * 0.62) + '" ry="' + (h * 0.42) + '" fill="#d9536d"/></g>' : '') +
        '<path d="M' + L + ' Q' + topC + ' ' + R + '" stroke="#0f0506" stroke-width="7" fill="none" stroke-linecap="round"/>' +
        (h > 7 ? '<path d="M' + L + ' Q' + botC + ' ' + R + '" stroke="#0f0506" stroke-width="4" fill="none" stroke-linecap="round" opacity=".85"/>' : '') +
        '<path d="M' + (cx - w * 0.55) + ' ' + (cyT - lift * 0.35) + ' Q' + (cx - w * 0.2) + ' ' + (cyT + 1) + ' ' + (cx + w * 0.05) + ' ' + (cyT + 2) + '" stroke="rgba(255,255,255,.45)" stroke-width="2.5" fill="none" stroke-linecap="round"/>';
    } else { mo = 0; mouthSvg.innerHTML = ""; }
    // ojos: parpadeo / squint / guiño / rubor
    var now = performance.now(), html = "", showPatch = false;
    if (g.eyes && g.eyes.length && !spinning) {
      if (now > nextBlink) { blinkUntil = now + 120; nextBlink = now + 2200 + Math.random() * 3200; }
      var blinking = now < blinkUntil, emoAge = now - emoT0;
      var sq = squint && emoAge < 2600, wk = winkSide >= 0 && emoAge < 1400;
      if (blinking || sq || wk) {
        showPatch = true;
        g.eyes.forEach(function (e, i) {
          if (wk && !blinking && i !== winkSide) { return; }
          var x = e[0], y = e[1], rx = e[2], ry = e[3];
          html += sq || (wk && i === winkSide)
            ? '<path d="M' + (x - rx * 0.95) + ' ' + (y + ry * 0.15) + ' Q' + x + ' ' + (y - ry * 0.75) + ' ' + (x + rx * 0.95) + ' ' + (y + ry * 0.15) + '" stroke="#1a0d0d" stroke-width="9" fill="none" stroke-linecap="round"/>'
            : '<path d="M' + (x - rx) + ' ' + (y + ry * 0.1) + ' Q' + x + ' ' + (y + ry * 0.55) + ' ' + (x + rx) + ' ' + (y + ry * 0.1) + '" stroke="#1a0d0d" stroke-width="8" fill="none" stroke-linecap="round"/>';
        });
        ep.style.clipPath = (wk && !blinking && !sq) ? (winkSide === 1 ? "inset(0 0 0 50%)" : "inset(0 50% 0 0)") : "none";
      }
      if ((emotion === "love" || emotion === "shy") && now - emoT0 < 3500) {
        g.eyes.forEach(function (e) { html += '<ellipse cx="' + (e[0] + (e[0] < 380 ? -10 : 10)) + '" cy="' + (e[1] + e[3] * 1.35) + '" rx="34" ry="17" fill="rgba(255,90,120,.45)"/>'; });
      }
    }
    ep.style.opacity = showPatch ? "1" : "0";
    eyesSvg.innerHTML = html;
  }
  var SPIN_SEQ = [["v-34", 1], ["v-side", 1], ["v-back", 1], ["v-side", -1], ["v-34", -1]];
  function spinStep(now) {
    if (!spinFrames) return null;
    var i = Math.floor((now - spinT0) / 95);
    LOOKS.forEach(function (k) { looks[k].classList.remove("on"); });
    if (i >= SPIN_SEQ.length) { spinFrames = null; looks[look].classList.add("on"); return null; }
    looks[SPIN_SEQ[i][0]].classList.add("on"); return SPIN_SEQ[i][1];
  }
  // salto con anticipación: agacha (0-18%) → estira y sube → aterriza aplastado → el resorte asienta
  function hop(u, height) {
    if (u < 0 || u > 1) return null;
    if (u < 0.18) { var a = u / 0.18; return { y: 3 * a, sx: 0.04 * a, sy: -0.05 * a }; }
    var v = (u - 0.18) / 0.82, up = Math.sin(v * Math.PI);
    var land = v > 0.85 ? (v - 0.85) / 0.15 : 0;
    return { y: -height * up, sx: -0.025 * up + 0.035 * land, sy: 0.04 * up - 0.045 * land };
  }
  function addHop(tg, u, height) { var h = hop(u, height); if (h) { tg.y += h.y; tg.sx += h.sx; tg.sy += h.sy; } }
  function armTargets(t, age, o) {
    var L = Math.sin(t * 1.1) * 3, R = -Math.sin(t * 1.1 + 0.8) * 3;   // idle: balanceo suave
    if (phase === "listening") { L = -6 + Math.sin(t * 1.4) * 2; R = 6 - Math.sin(t * 1.4) * 2; }
    if (phase === "thinking") { L = -5; R = -16 + Math.sin(t * 6) * 5; }   // un brazo arriba "tamborileando"
    if (phase === "speaking") {   // gesticula al ritmo de la voz
      var g1 = 0.5 + 0.5 * Math.sin(t * 2.1) * Math.sin(t * 0.73 + 1.1), g2 = 0.5 + 0.5 * Math.sin(t * 1.7 + 2) * Math.sin(t * 0.61);
      L = 2 + 8 * g1 * (0.5 + 0.5 * mo); R = -(2 + 8 * g2 * (0.5 + 0.5 * mo));
    }
    if (greetWave && age < 2) { R = -30 + Math.sin(age * 11) * 12; }   // saludo con la mano
    if (age < 1.8) {
      var k = 1 - age / 1.8;
      if (emotion === "happy") { L += 14 * k; R -= 14 * k; }
      if (emotion === "excited") { var j = Math.abs(Math.sin(age * 8)); L = 16 + 6 * j; R = -16 - 6 * j; }
      if (emotion === "surprised") { L = 22 * Math.min(1, age * 6) * k + L * (1 - k); R = -22 * Math.min(1, age * 6) * k + R * (1 - k); }
      if (emotion === "laugh") { L += Math.sin(age * 30) * 7 * k + 8; R -= Math.sin(age * 30) * 7 * k + 8; }
      if (emotion === "love") { L = 22; R = -22; }
      if (emotion === "proud") { L = 16; R = -16; }
      if (emotion === "shy") { L = -12; R = 12; }
      if (emotion === "wink") { R = -24 + Math.sin(age * 11) * 10 * k; }
      if (emotion === "cool") { L = 9; R = -4; }
    }
    if (emotion === "dance" && (phase === "speaking" || age < 4)) { var b = t * 2 * Math.PI * 2.1; L = 14 + 12 * Math.sin(b / 2); R = -14 - 12 * Math.sin(b / 2 + Math.PI); }
    var m = ARMK[look] || 1; return { L: L * m, R: R * m };
  }
  function loop() {
    requestAnimationFrame(loop);
    if (!isOpen) return;
    var now = performance.now(), t = now / 1000, age = (now - emoT0) / 1000;
    var tg = { x: 0, y: 0, r: 0, sx: 1, sy: 1 };
    // respiración (siempre)
    var br = Math.sin(t * 2.2);
    // respiración como el botón (≈3,5 %) y un leve flote
    tg.sy += br * 0.017; tg.sx -= br * 0.012; tg.y -= (br + 1) * 0.8;
    var o = mouthOpen(t);
    if (phase === "speaking") { tg.y -= Math.abs(Math.sin(t * 3.1)) * 4 * (0.5 + o * 0.5); tg.sy += o * 0.008; }
    if (phase === "listening") { tg.sx += 0.012; tg.sy += 0.012; }
    if (phase === "thinking") { tg.y -= Math.abs(Math.sin(t * 2.2)) * 3; }
    // one-shots
    if (age < 1.6) {
      var k = 1 - age / 1.6;
      if (emotion === "happy") addHop(tg, age / 0.62, 20);
      if (emotion === "excited") { addHop(tg, age / 0.5, 30); addHop(tg, (age - 0.55) / 0.5, 22); }
      if (emotion === "laugh") { tg.y -= Math.abs(Math.sin(age * 16)) * 7 * k; }
      if (emotion === "surprised") { addHop(tg, age / 0.55, 44); if (age < 0.9) { tg.sy += 0.05 * (1 - age / 0.9); } }
      if (emotion === "proud") { tg.sx += 0.025 * k; tg.sy += 0.025 * k; tg.y -= 6 * k; }
      if (emotion === "shy") { tg.y += 2 * k; }
      if (emotion === "cool") { tg.y -= 4 * k; }
      if (emotion === "wink") { addHop(tg, age / 0.5, 10); }
      if (emotion === "love") { addHop(tg, age / 0.7, 14); addHop(tg, (age - 0.75) / 0.7, 10); }
    }
    // baile (mientras habla o 4 s después)
    if (emotion === "dance" && (phase === "speaking" || age < 4)) {
      var b = t * 2 * Math.PI * 2.1;
      tg.y -= Math.abs(Math.sin(b / 2)) * 22; tg.x += Math.sin(b / 4) * 14;
      tg.sy += Math.abs(Math.cos(b / 2)) * 0.02; tg.sx -= Math.abs(Math.cos(b / 2)) * 0.015;
      if (now - lastSpin > 2300) { lastSpin = now; if (Math.random() < 0.7) burst(["🎶", "🎵"], 2); }
    } else if (root.classList.contains("dance") && age > 4) root.classList.remove("dance");
    var la = t - lookT0;
    if (la >= 0 && la < 0.22) { var q = la / 0.22; tg.sx -= 0.08 * q; tg.sy -= 0.08 * q; }
    var flip = spinStep(now);
    // resorte amortiguado (ζ≈0,65): sobrepaso leve + asentamiento natural (follow-through)
    var dt = Math.min(0.05, lastF ? (now - lastF) / 1000 : 0.016); lastF = now;
    var W = 15, Z = 0.65, K = W * W, C = 2 * Z * W;
    ["x", "y", "r", "sx", "sy"].forEach(function (p) { vel[p] += (K * (tg[p] - cur[p]) - C * vel[p]) * dt; cur[p] += vel[p] * dt; });
    if (shadowEl) { var hgt = Math.max(0, -cur.y); shadowEl.style.transform = "scale(" + (1 - Math.min(0.45, hgt / 110)).toFixed(3) + ")"; shadowEl.style.opacity = (1 - Math.min(0.6, hgt / 90)).toFixed(2); }
    // la inclinación es un "skew" desde los pies (quedan plantados); el ángulo del look se corrige con rotate
    ch.style.transform = "translate(" + cur.x.toFixed(1) + "px," + cur.y.toFixed(1) + "px) rotate(" + (TILT[look] || 0) + "deg) scale(" + (cur.sx * (flip === -1 ? -1 : 1)).toFixed(3) + "," + cur.sy.toFixed(3) + ")";
    var at = armTargets(t, age, o);
    ["L", "R"].forEach(function (sd) { armV[sd] += (120 * (at[sd] - armA[sd]) - 2 * 0.55 * 11 * armV[sd]) * dt; armA[sd] += armV[sd] * dt; var e = armEls[look + sd]; if (e) e.style.transform = "rotate(" + armA[sd].toFixed(2) + "deg)"; });
    drawFace(t, o);
  }

  // ── fases / UI ─────────────────────────────────────────────────────
  function setPhase(p) { phase = p; ["listening", "thinking", "speaking"].forEach(function (c) { root.classList.toggle(c, p === c); }); }
  function setState(s) { if (stateTxt) stateTxt.textContent = s; }
  function typeCaption(text, heard, durS) {
    var full = plain(text), i = 0;
    // al ritmo de la voz: 2 caracteres por paso repartidos en la duración del audio
    var stepMs = durS ? Math.max(18, Math.min(90, (durS * 1000 * 0.92) / Math.max(1, full.length / 2))) : 40;
    cap.innerHTML = (heard ? "<small>Tú: " + esc(heard) + "</small>" : "") + "<span></span>";
    var span = cap.querySelector("span");
    (function tick() { if (!isOpen) return; i = Math.min(full.length, i + 2); span.textContent = full.slice(0, i); cap.scrollTop = cap.scrollHeight; if (i < full.length) setTimeout(tick, stepMs); })();
  }

  // ── contexto de la visita ──────────────────────────────────────────
  function pageType() {
    try { var t = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType; if (t) return String(t).toLowerCase(); } catch (e) {}
    var p = location.pathname; return /\/products\//.test(p) ? "product" : /\/collections\//.test(p) ? "collection" : /\/cart/.test(p) ? "cart" : p === "/" ? "home" : "page";
  }
  function loadProduct() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return Promise.resolve(null);
    return fetch("/products/" + m[1] + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return null; var v = (p.variants || [])[0] || {};
      productInfo = { title: p.title, price: Math.round((v.price || p.price || 0) / 100), available: v.available !== false, variantId: v.id, handle: p.handle, desc: cleanDesc(p.description) }; return productInfo;
    }).catch(function () { return null; });
  }
  // descripción/notas de la ficha (300-400 caracteres limpios) → Mojo sabe cómo huele y qué trae un kit
  function cleanDesc(html, max) {
    max = max || 400;
    try {
      var t = String(html || "").replace(/<(br|\/p|\/li|\/h\d)[^>]*>/gi, ". ").replace(/<li[^>]*>/gi, " - ").replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;|&rsquo;|&lsquo;/g, "'").replace(/&[a-z]+;/gi, " ")
        .replace(/\s+/g, " ").replace(/(\.\s*){2,}/g, ". ").replace(/:\s*\.\s*/g, ": ").replace(/\s+\./g, ".").replace(/\.\s*-\s*/g, ". ").replace(/^\s*descripci[oó]n:\s*/i, "").replace(/^[\s.:\-]+/, "").trim();
      var b = t.search(/(en primer lugar,? tienes que devolvernos|garant[ií]a de satisfacci[oó]n|pol[ií]tica de devoluci|utilizaremos la fecha de env[ií]o|no pierdas la chance)/i); if (b > 40) t = t.slice(0, b).trim();
      var n = t.search(/notas olfativas|notas de salida|salida:/i);
      if (n > 0 && t.length > max) { var first = (t.slice(0, n).match(/^[^.!?]{10,140}[.!?]/) || [""])[0]; t = (first ? first + " " : "") + t.slice(n); }
      if (t.length > max) t = t.slice(0, max).replace(/\s+\S*$/, "") + "…";
      return t;
    } catch (e) { return ""; }
  }
  function getCart() {
    return fetch("/cart.js").then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      if (!c) return null;
      var dc = (c.discount_codes || [])[0];
      lastDisc = { code: (dc && dc.code) || discCookie(), saved: Math.round((c.total_discount || 0) / 100) };
      return { count: c.item_count || 0, total: Math.round((c.total_price || 0) / 100), items: (c.items || []).slice(0, 8).map(function (i) { var pr = []; try { Object.keys(i.properties || {}).forEach(function (k) { if (k.charAt(0) !== "_" && i.properties[k]) pr.push(k + ": " + i.properties[k]); }); } catch (e) {} if (i.variant_title && !/default/i.test(i.variant_title)) pr.unshift(i.variant_title); return { title: i.product_title, qty: i.quantity, props: pr.join(" · ").slice(0, 300) }; }) };
    }).catch(function () { return null; });
  }
  // código de descuento con el que llegó (links /discount/CODE o ?discount=CODE): Shopify lo guarda en la cookie discount_code
  var lastDisc = null;
  function discCookie() {
    try { var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/); if (m) return decodeURIComponent(m[1]); } catch (e) {}
    try { var q = new URLSearchParams(location.search).get("discount"); if (q) return q; } catch (e) {}
    return "";
  }
  function context() {
    return getCart().then(function (cart) {
      var visit = ssGet("srn_visit_v1", { viewed: [] });
      var c = { pageType: pageType(), cart: cart, viewed: (visit.viewed || []).map(function (x) { return { title: x.title }; }) };
      if (productInfo) c.product = productInfo;
      if (profile) c.profile = profile;
      if (mini) c.mode = "mini";
      var cm = location.pathname.match(/\/collections\/([^/?#]+)/);
      if (cm && cm[1] !== "all" && !productInfo) {
        var ct = ""; try { ct = (document.querySelector("h1") || {}).textContent || ""; } catch (e) {}
        c.collection = { handle: decodeURIComponent(cm[1]).slice(0, 120), title: String(ct).replace(/\s+/g, " ").trim().slice(0, 80) };
      }
      var dcode = (lastDisc && lastDisc.code) || discCookie();
      if (dcode) c.discount = { code: String(dcode).slice(0, 60), saved: (lastDisc && lastDisc.saved) || 0 };
      if (arrived) { c.arrived = arrived; arrived = ""; }
      return c;
    });
  }

  // ── audio de salida ────────────────────────────────────────────────
  function ensureAudio() {
    if (audioEl) return audioEl;
    audioEl = new Audio(); audioEl.preload = "auto"; audioEl.setAttribute("playsinline", ""); return audioEl;
  }
  function unlockAudio() {
    var a = ensureAudio();
    try { a.muted = true; a.src = silentWavUrl(); var p = a.play(); if (p && p.then) p.then(function () { a.pause(); a.muted = muted; }).catch(function () { a.muted = muted; }); } catch (e) {}
    try { var AC = window.AudioContext || window.webkitAudioContext; if (AC && !actx) actx = new AC(); if (actx && actx.state === "suspended") actx.resume(); } catch (e) {}
  }
  function play(b64, onend) {
    var a = ensureAudio(); var done = false;
    var fin = function () { if (done) return; done = true; onend && onend(); };
    if (!b64) { setTimeout(fin, 2400); return; }
    a.onended = fin; a.onerror = fin; a.muted = muted;
    a.src = /^(https?:)?\/\//.test(b64) ? b64 : "data:audio/mpeg;base64," + b64;
    var p = a.play(); if (p && p.catch) p.catch(function () { root.classList.add("needtap"); setState(""); a.onplay = function () { root.classList.remove("needtap"); }; });
  }

  // ── micrófono + VAD (manos libres) ─────────────────────────────────
  function micReady() {
    if (stream) return Promise.resolve(true);
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) return Promise.resolve(false);
    var noteT = 0;
    if (AB === "B" && root) { noteT = setTimeout(function () { root.classList.add("micask"); }, 250); } // solo si el navegador de verdad muestra el aviso (si ya hay permiso resuelve antes)
    var hideNote = function () { clearTimeout(noteT); if (root) setTimeout(function () { root.classList.remove("micask"); }, 600); };
    return navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } }).then(function (s) {
      stream = s;
      try { var AC = window.AudioContext || window.webkitAudioContext; if (!actx) actx = new AC(); var src = actx.createMediaStreamSource(s); analyser = actx.createAnalyser(); analyser.fftSize = 1024; src.connect(analyser); } catch (e) {}
      hideNote(); return true;
    }).catch(function () { hideNote(); return false; });
  }
  function rms() {
    if (!analyser) return 0; var d = new Float32Array(analyser.fftSize); analyser.getFloatTimeDomainData(d);
    var s = 0; for (var i = 0; i < d.length; i++) s += d[i] * d[i]; return Math.sqrt(s / d.length);
  }
  function pickMime() {
    var c = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/aac"];
    for (var i = 0; i < c.length; i++) if (window.MediaRecorder && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(c[i])) return c[i];
    return "";
  }
  function startListening() {
    if (!isOpen || busy || paused) return;
    micReady().then(function (ok) {
      if (!ok) { setTyping(true); setState("Sin micrófono · escríbele a Mojo"); setPhase("idle"); return; }
      // al llegar a otra página el navegador puede dejar el audio "dormido" hasta un toque
      try { if (actx && actx.state === "suspended") { actx.resume(); if (actx.state === "suspended") { root.classList.add("needtap"); setState(""); return; } } } catch (e) {}
      setPhase("listening"); setState("Te escucho… habla cuando quieras");
      chunks = []; var mime = pickMime();
      try { rec = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream); } catch (e) { rec = new MediaRecorder(stream); }
      rec.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
      rec.start(250);
      var t0 = performance.now(), hist = [], speech = false, voiceMs = 0, lastVoice = 0, prev = t0;
      clearInterval(vadTimer);
      vadTimer = setInterval(function () {
        var now = performance.now(), dt = now - prev; prev = now; var v = rms();
        // ruido de fondo = mínimo de los últimos ~2 s (no se contamina si ya está hablando)
        hist.push(v); if (hist.length > 34) hist.shift();
        var floor = Math.max(0.004, Math.min.apply(null, hist));
        var thr = Math.min(0.045, Math.max(0.016, floor * 3));
        if (lvl) lvl.style.setProperty("--l", (1 + Math.min(0.35, v * 6)).toFixed(2));
        if (v > thr) { voiceMs += dt; lastVoice = now; if (voiceMs > 140 && !speech) { speech = true; setState("Te escucho… 🎧"); } }
        else voiceMs = Math.max(0, voiceMs - dt * 0.5);
        if (speech && now - lastVoice > 850) { finishRecording(); }
        else if (!speech && now - t0 > 14000) { stopListening(true); setPhase("idle"); paused = true; root.classList.add("paused"); setState("¿Sigues ahí? Toca el micrófono para hablar"); }
        else if (speech && now - t0 > 20000) { finishRecording(); }
      }, 60);
    });
  }
  function stopListening(discard) {
    clearInterval(vadTimer); vadTimer = null; if (lvl) lvl.style.setProperty("--l", 1);
    if (rec && rec.state !== "inactive") { if (discard) rec.ondataavailable = null; try { rec.stop(); } catch (e) {} }
  }
  function finishRecording() {
    clearInterval(vadTimer); vadTimer = null;
    var r = rec; if (!r) return;
    r.onstop = function () {
      var type = (r.mimeType || "audio/webm"); var blob = new Blob(chunks, { type: type });
      if (blob.size < 1500) { startListening(); return; }
      var fr = new FileReader();
      fr.onload = function () { var b64 = String(fr.result).split(",")[1] || ""; turn({ audio: b64, mime: type }); };
      fr.readAsDataURL(blob);
    };
    try { r.stop(); } catch (e) {}
  }

  // ── turno de conversación ──────────────────────────────────────────
  var lastOffer = [];
  // audios pregrabados (voz de Mojo): saludo instantáneo + muletillas mientras piensa
  var ASSET_BASE = ((SCRIPT && SCRIPT.src) || "").replace(/mojo-live\.js.*$/, "");
  var V = (((SCRIPT && SCRIPT.src) || "").match(/[?&]v=(\d+)/) || [])[1] || "1";
  function asset(n) { return ASSET_BASE + n + ".mp3?v=" + V; }
  var GREET = { home: "¡Hola! Soy Mojo, tu asesor de Serené. ¿Buscas algo dulce, fresco, o para regalar? Háblame, o toca una opción aquí abajo.",
    product: "¡Hola! Soy Mojo, tu asesor de Serené. ¿Te cuento cómo huele este perfume? Háblame, o toca una opción aquí abajo." };
  var FILLS = ["mojo-fill-1", "mojo-fill-2", "mojo-fill-3", "mojo-fill-4"], fillN = Math.floor(Math.random() * 4), fillOn = false, afterFill = null;
  function playFiller() {
    var a = ensureAudio(); fillOn = true; var end = function () { if (!fillOn) return; fillOn = false; if (afterFill) { var f = afterFill; afterFill = null; f(); } };
    a.onended = end; a.onerror = end; a.muted = muted; a.src = asset(FILLS[fillN++ % FILLS.length]);
    var p = a.play(); if (p && p.catch) p.catch(end); setTimeout(end, 2600);
  }
  function greetLocal(sysText) {
    var onProduct = /\/products\//.test(location.pathname), text = onProduct ? GREET.product : GREET.home;
    history.push({ role: "user", content: sysText }); history.push({ role: "assistant", content: text });
    setPhase("speaking"); setState("Mojo está hablando…"); react("happy"); showChips();
    typeCaption(text, "", onProduct ? 7.5 : 8.4);
    play(asset(onProduct ? "mojo-hola-producto" : "mojo-hola"), function () { if (!isOpen) return; setPhase("idle"); if (!paused && !root.classList.contains("typing")) { startListening(); setState("Te escucho 🎤 Habla cuando quieras"); } });
    saveState();
  }
  function turn(input, typedText) {
    if (busy) return; busy = true;
    setPhase("thinking"); setState("Mojo está pensando…"); react("thinking");
    var userTurn = !!(input.audio || (input.text && !/^\(/.test(input.text))), fillT = userTurn ? setTimeout(function () { if (busy && isOpen) playFiller(); }, 700) : 0;
    if (typedText) cap.innerHTML = "<small>Tú: " + esc(typedText) + "</small>";
    if (input.audio || (input.text && !/^\(/.test(input.text))) hideChips();
    if (userTurn && !talked) { talked = true; logEv("talk", { sku: input.audio ? "voz" : input.chip ? "chip" : "texto" }); } // 1er mensaje (A/B: habla%)
    context().then(function (ctx) {
      ctx.lastOffer = lastOffer.slice(0, 6);
      var body = { history: history.slice(-20), context: ctx, sid: SID, ab: AB };
      if (input.audio) { body.audio = input.audio; body.mime = input.mime; } else body.text = input.text;
      return fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
    }).then(function (d) {
      busy = false; clearTimeout(fillT); if (!isOpen) return;
      var sys = !!(input.text && /^\(/.test(input.text)); // mensaje interno (saludo inicial, carrito)
      var heard = sys ? "" : (d.heard || typedText || input.text || "");
      if (!d.silence) { // silencio/ruido: no ensucia el historial
        history.push({ role: "user", content: sys ? input.text : heard });
        history.push({ role: "assistant", content: plain(d.reply || "") });
      }
      // productos que Mojo acaba de ofrecer (links + tarjetas): si el cliente responde "sí", el servidor sabe cuál agregar
      if (!d.silence) lastOffer = []; String(d.reply || "").replace(/\]\((https?:\/\/[^)\s]+)\)/g, function (m, u) { var h = (u.match(/\/products\/([^/?#]+)/) || [])[1]; if (h && lastOffer.indexOf(h) < 0) lastOffer.push(h); return m; });
      (d.actions || []).forEach(function (x) { if (x.type === "add" && !x.now) { var h = x.current ? (productInfo && productInfo.handle) : (String(x.url || "").match(/\/products\/([^/?#]+)/) || [])[1]; if (h && lastOffer.indexOf(h) < 0) lastOffer.push(h); } });
      if (d.profile) profile = String(d.profile).slice(0, 400);
      saveState();
      var nl = pickLook(d.look, d.emotion); var lookChanges = nl !== look;
      if (lookChanges) changeLook(nl);
      var speak = function () { setTimeout(function () {
        setPhase("speaking"); setState("Mojo está hablando…"); react(d.emotion || "happy");
        typeCaption(d.reply || "", heard, d.audio ? d.audio.length * 0.75 * 8 / 64000 : 0);
        (d.actions || []).forEach(renderAction);
        play(d.audio, function () { if (!isOpen) return; setPhase("idle");
          if (pendingGo) { snapshot(); var g = pendingGo; pendingGo = null; goArrive = g.title || "el producto"; saveState({ open: true, mini: true }); toast("Te llevo a verlo… 👀"); setTimeout(function () { location.href = g.url; }, 500); return; } if (!paused && !root.classList.contains("typing")) startListening(); else setState(root.classList.contains("typing") ? "Escríbele a Mojo" : "Pausado · toca para hablar"); });
      }, lookChanges ? 260 : 0); };
      if (fillOn) afterFill = speak; else speak();
    }).catch(function () {
      busy = false; clearTimeout(fillT); fillOn = false; afterFill = null; if (!isOpen) return; setPhase("idle"); react("shy");
      cap.textContent = "Uy, se me fue la señal un segundo 😅 Toca el micrófono y me repites, porfa.";
      setState("Toca el micrófono para hablar"); paused = true; root.classList.add("paused");
    });
  }

  // ── carrito: agregar (botón o directo si lo pidió), quitar, finalizar ─
  function drawerEl() { return document.querySelector("cart-drawer"); }
  function sectionsFor(payload) {
    var d = drawerEl();
    if (d && d.getSectionsToRender) { payload.sections = d.getSectionsToRender().map(function (s) { return s.id; }); payload.sections_url = location.pathname; }
    return payload;
  }
  function refreshDrawer(j) {
    try {
      var d = drawerEl();
      if (d && j && j.sections && d.renderContents) {
        d.classList.toggle("is-empty", !(j.item_count > 0 || (j.items && j.items.length) || j.id));
        d.renderContents(j);
      } else {
        fetch(location.pathname + "?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (sec) {
          var b = document.getElementById("cart-icon-bubble"); if (b && sec["cart-icon-bubble"]) { var tmp = document.createElement("div"); tmp.innerHTML = sec["cart-icon-bubble"]; var inn = tmp.querySelector("#cart-icon-bubble") || tmp; b.innerHTML = inn.innerHTML; }
        }).catch(function () {});
      }
    } catch (e) {}
  }
  function productJs(handle) { return fetch("/products/" + handle + ".js").then(function (r) { if (!r.ok) throw new Error("producto"); return r.json(); }); }
  // las agregadas van EN FILA: si Mojo agrega 3 de una vez (kit), Shopify no pierde ninguna
  var addQueue = Promise.resolve();
  function addToCart(handle, qty, sku) {
    var run = function () { return addToCartNow(handle, qty, sku); };
    var pr = addQueue.then(run, run); addQueue = pr.catch(function () {}); return pr;
  }
  function addToCartNow(handle, qty, sku) {
    return productJs(handle).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) throw new Error("agotado");
      var payload = sectionsFor({ id: v.id, quantity: qty || 1, properties: { _mojo: "1", _mojo_sid: SID } }); // _mojo_sid por línea: llega al pedido aunque sea contra entrega (EasySell)
      return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || "error"); return { j: j, p: p }; }); });
    }).then(function (res) {
      logEv("add", { sku: sku || handle });
      try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { _recomendado_por: "Mojo (bot IA)", _aura_sku: sku || handle, _mojo_live: "1", _mojo_sid: SID } }) }); } catch (e) {}
      refreshDrawer(res.j); return res;
    });
  }
  function removeFromCart(a) {
    if (a.all) {
      return fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function () { refreshDrawer(null); return syncCards(); });
    }
    var payload = sectionsFor({ line: a.line, quantity: 0 });
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || "error"); refreshDrawer(j); return syncCards(); }); });
  }
  // las tarjetas reflejan SIEMPRE el carrito real (agregado / no agregado)
  function syncCards() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      var inCart = {}; (c.items || []).forEach(function (i) { inCart[i.handle] = true; });
      cards.querySelectorAll(".mjl-pc").forEach(function (pc) {
        var b = pc.querySelector("button"); if (!b || pc._busy) return;
        if (inCart[pc.getAttribute("data-h")]) { b.className = "ok"; b.textContent = "✓ Agregado"; b.disabled = true; }
        else { b.className = ""; b.textContent = "Agregar 🛒"; b.disabled = false; }
      });
      return c;
    }).catch(function () {});
  }
  function toast(msg) { var t = el("div", "mjl-toast", msg); card.appendChild(t); setTimeout(function () { t.classList.add("on"); }, 20); setTimeout(function () { t.classList.remove("on"); setTimeout(t.remove.bind(t), 400); }, 2600); }

  function renderAction(a) {
    if (a.type === "checkout" || a.type === "cart") {
      if (cards.querySelector(".mjl-cta-wrap")) return;
      var wrap = el("div", "mjl-pay mjl-cta-wrap");
      var cod = el("button", "mjl-cta", "💵 Pagar al recibir"), web = el("button", "mjl-cta alt", "💳 Pagar en línea");
      var go = function (method) {
        getCart().then(function (c) {
          if (!c || !c.count) { toast("Tu carrito está vacío 🛒 Dile a Mojo “agrégalo” o toca Agregar"); return; }
          logEv("checkout", { total: c.total, count: c.count, sku: method });
          close();
          if (method === "online") { setTimeout(function () { location.href = "/checkout"; }, 250); return; }
          // contra entrega: abre el formulario EasySell directamente (en el cajón del carrito o en /cart)
          setTimeout(function () {
            var d = drawerEl(); if (d && d.open) d.open();
            var tries = 0, t = setInterval(function () {
              var b = document.querySelector(".es-popup-button-drawer, .es-popup-button-cart, #es-popup-button");
              if (b && b.offsetParent !== null) { clearInterval(t); b.click(); }
              else if (++tries > 20) { clearInterval(t); location.href = "/cart"; }
            }, 150);
          }, 320);
        });
      };
      cod.onclick = function () { go("cod"); }; web.onclick = function () { go("online"); };
      wrap.appendChild(cod); wrap.appendChild(web); cards.appendChild(wrap); return;
    }
    if (a.type === "go") {
      if (a.url) pendingGo = { url: a.url, title: (a.title || "").split("—")[0].trim() };
      return;
    }
    if (a.type === "remove") {
      logEv("remove", {});
      removeFromCart(a).then(function () { toast(a.all ? "🗑️ Vacié tu carrito" : "🗑️ Listo, lo saqué del carrito"); })
        .catch(function () { toast("No pude quitarlo 😕 Inténtalo otra vez"); });
      return;
    }
    if (a.type !== "add") return;
    var handle = a.current ? (productInfo && productInfo.handle) : ((String(a.url || "").match(/\/products\/([^/?#]+)/) || [])[1]);
    if (!handle) return;
    var c = cards.querySelector('[data-h="' + handle + '"]');
    if (!c) {
      c = el("div", "mjl-pc"); c.setAttribute("data-h", handle);
      c.innerHTML = '<img alt=""><div class="t"><b>' + esc(a.title ? String(a.title).split("—")[0] : (productInfo ? productInfo.title : "Serené")) + "</b>" + esc(a.price || (productInfo ? "$" + productInfo.price.toLocaleString("es-CO") : "")) + "</div>";
      var btn0 = el("button", "", "Agregar 🛒"); c.appendChild(btn0); cards.prepend(c); if (!a.now) syncCards();
      productJs(handle).then(function (p) {
        var img = c.querySelector("img"); if (p.featured_image) img.src = (p.featured_image.indexOf("//") === 0 ? "https:" : "") + p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=160";
        if (!a.title) c.querySelector("b").textContent = p.title;
      }).catch(function () {});
    }
    var btn = c.querySelector("button");
    var doAdd = function (fromVoice) {
      if (c._busy) return; c._busy = true; btn.disabled = true; btn.textContent = "…";
      addToCart(handle, a.qty, a.sku).then(function (res) {
        c._busy = false; btn.className = "ok"; btn.textContent = "✓ Agregado";
        if (!fromVoice) { stopListening(true); turn({ text: "(Sistema: el cliente acaba de agregar " + (res.p.title || "el producto") + " al carrito tocando el botón. Celebra con emotion dance, felicítalo corto y propón UN complemento con la promo activa o finalizar con {{CHECKOUT}}.)" }); }
        else toast("🛒 Agregado al carrito");
      }).catch(function (e) {
        c._busy = false; btn.disabled = false; btn.textContent = "Agregar 🛒";
        toast(/agotado/.test(String(e && e.message)) ? "Uy, ese está agotado ahorita 😕" : "No pude agregarlo 😕 Inténtalo otra vez");
      });
    };
    btn.onclick = function () { doAdd(false); };
    if (a.now) doAdd(true); // el cliente lo pidió de viva voz → se agrega ya
  }

  // ── abrir / cerrar ─────────────────────────────────────────────────
  // respuestas rápidas: para quien no quiere hablar en voz alta (la mayoría abre y se va sin decir nada)
  var chips;
  function showChips(tries) {
    if (!chips) return;
    if (AB !== "B" && !productInfo && /\/products\//.test(location.pathname) && (tries || 0) < 8) { setTimeout(function () { showChips((tries || 0) + 1); }, 400); return; } // espera a leer el producto
    chips.innerHTML = "";
    var opts = (productInfo || (AB === "B" && /\/products\//.test(location.pathname))) ? ["¿Cómo huele este? 👃", "Ayúdame a elegir ✨", "¿Qué promos hay? 🎁"] : ["Ayúdame a elegir ✨", "Busco algo dulce 🍬", "¿Qué promos hay? 🎁"];
    opts.forEach(function (t) { var b = el("button", "mjl-chip", t); b.onclick = function () { hideChips(); stopListening(true); turn({ text: t.replace(/\s*\S+$/, ""), chip: true }, t.replace(/\s*\S+$/, "")); logEv("chip", { sku: t.slice(0, 30) }); }; chips.appendChild(b); });
    chips.classList.add("on");
  }
  function hideChips() { if (chips) chips.classList.remove("on"); }
  function open(opts) {
    opts = opts || {};
    build();
    if (isOpen) return; isOpen = true; paused = false; SID = sessionId();
    var st = opts.resume ? readState() : null;
    if (st) { history = st.history || []; profile = st.profile || ""; greeted = !!st.greeted; if (st.look && GEO[st.look]) look = st.look; if (st.arrive) arrived = st.arrive; }
    mini = !!(opts.mini || opts.nudge || (st && st.mini));
    document.querySelectorAll(".srn-nudge").forEach(function (n) { n.remove(); });
    try { sessionStorage.setItem("srn_opened", "1"); } catch (e) {}
    unlockAudio();
    root.style.display = "flex"; requestAnimationFrame(function () { root.classList.add("on"); });
    root.classList.toggle("mini", mini);
    document.documentElement.style.overflow = mini ? "" : "hidden";
    queueDodge();
    applyLookImgs(look);
    talked = history.some(function (m) { return m.role === "user" && !/^\(/.test(String(m.content || "")); });
    if (AB === "B") setTyping(textFirst() || root.classList.contains("typing"));
    loadProduct();
    if (!greeted) {
      greeted = true;
      if (!textFirst()) micReady(); // pide permiso ya, dentro del gesto (B en móvil: solo si toca el micrófono)
      greetWave = true;
      logEv("open", { sku: opts.nudgeId || "boton" });
      greetLocal(opts.nudge ? "(El cliente tocó el globo \"" + String(opts.nudge).slice(0, 160) + "\" en la página del producto y abrió la llamada. Ya lo saludaste.)" : "(El cliente abrió la llamada contigo desde la web de Serené. Ya lo saludaste.)");
      try { fetch(ENDPOINT.replace(/\/voice$/, "/health"), { mode: "cors" }); } catch (e) {} // calienta el servidor
    } else if (opts.resume && arrived) {
      // llegó a la página del producto que Mojo le mostró: lo comenta y sigue la venta
      turn({ text: "(Sistema: el cliente llegó a la página de " + arrived + " que le recomendaste.)" });
    } else if (!root.classList.contains("typing")) { startListening(); } else { setPhase("idle"); setState("Escríbele a Mojo"); }
    goArrive = ""; saveState({ arrive: "" });
  }
  function close() {
    if (!isOpen) return; snapshot(); isOpen = false;
    getCart().then(function (c) { logEv("close", { total: c ? c.total : 0, count: c ? c.count : 0 }); });
    stopListening(true); setPhase("idle");
    try { if (audioEl) audioEl.pause(); } catch (e) {}
    root.classList.remove("on"); document.documentElement.style.overflow = "";
    saveState({ open: false });
    setTimeout(function () { if (!isOpen) root.style.display = "none"; }, 350);
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && isOpen) close(); });

  window.MojoLive = { open: open, close: close, ab: AB };
  window.addEventListener("load", function () {
    var st = readState();
    if (st && st.open && Date.now() - (st.t || 0) < 30 * 60 * 1000) setTimeout(function () { open({ resume: true }); }, 700);
  });
  // precarga liviana del look base cuando la página queda libre
  window.addEventListener("load", function () { setTimeout(function () { var i = new Image(); i.src = A("mojo-base.webp"); }, 2500); });
})();
